import { useFormikContext } from "formik";
import React, { FC } from "react";
import { CustomFieldBuilder } from "../../../containers/utilities/CustomFieldBuilder";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { DynamicFieldDescriptor } from "../../../models/DynamicFieldDescriptor";
import PresetCustomField from "../../../models/PresetCustomField";
import { getWizardContentDescription } from "../../../utilities/WizardContentUtil";

interface PresetDetailsProps {
    onNext: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onBack: (event: React.MouseEvent<HTMLButtonElement>) => void;
    supportedFields?: DynamicFieldDescriptor[] | undefined;
    currentItem?: PresetCustomField;
    setSideBarStepDescription: (newDescription: string) => void;
}

const PresetDetails: FC<PresetDetailsProps> = ({ onNext, onBack, supportedFields, currentItem, setSideBarStepDescription }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();
    const formik = useFormikContext();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);
    const allFieldsFilled = supportedFields?.every(field => {return values.custom?.[field.systemName].value});

    const createFields = () => {
        const DOSId = 2003;
        var arrayFields = [] as any[];
        if (currentItem?.sdist == 'GLOBAL' && currentItem?.typeId == DOSId) {
            supportedFields?.filter(field => {
                if (!field.systemName.includes('I_DOS_CONTACT_LA')) {
                    arrayFields.push(field);
                }
            });
        }
        else {
            arrayFields = supportedFields as any;
        }
        
        return arrayFields?.reduce((formFields, field) => customFieldBuilder.buildFormField(formFields, field, false, true, undefined), new Array(0)).map(fieldBundle => fieldBundle.map(field => field.content));
    }

    const onLocalNext = (event: React.MouseEvent<HTMLButtonElement>) => {
        let detailDescription = getWizardContentDescription(formik.values, supportedFields);
        setSideBarStepDescription(detailDescription.detailDescription);
        onNext(event);
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-col overflow-y-auto" style={{ height: '85%' }}>
            <div className="text-portal-blue-primary-shade2 text-xl font-semibold">{translate.byKey(TranslationKeys.details)}</div>
            <div className="flex flex-col pt-3">
                {createFields()}
            </div>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${!allFieldsFilled ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                    type='button'
                    disabled={!allFieldsFilled}
                    onClick={onLocalNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default PresetDetails;